import { useState } from "react";

import { Icon } from "@blueprintjs/core";

import { Box, Flex } from "@/components/layout/flexbox";
import { RoleplaySessionComment } from "@/components/pages_logged_in/roleplays/details/scenario/session/RoleplaySessionComment";
import { Collapsible } from "@/components/pieces/Collapsible";
import { RoleplaySessionCommentFragment } from "@/graphql";

interface RoleplaySessionCommentsProps {
  title: string;
  comments: RoleplaySessionCommentFragment[];
}

export function RoleplaySessionComments({
  comments = [],
  title,
}: RoleplaySessionCommentsProps) {
  const [showFeedback, setShowFeedback] = useState(true);

  return (
    <Collapsible
      onToggle={setShowFeedback}
      open={showFeedback}
      trigger={
        <Flex my={2} justifyContent="space-between">
          <Box fontSize={18} fontWeight={600}>
            {title}
          </Box>
          <Icon icon={showFeedback ? "chevron-up" : "chevron-down"} />
        </Flex>
      }
    >
      <Flex flexDirection="column">
        {comments.map((comment) => {
          return <RoleplaySessionComment comment={comment} />;
        })}
      </Flex>
    </Collapsible>
  );
}
